import { Autocomplete, TextField } from '@mui/material';

interface TagsFieldProps {
  label: string;
  helperText?: string;
  values: string[];
  onChange: (values: string[]) => void;
  /** Validates each entered value before it is accepted as a chip (e.g. the `key:value` tag pattern). */
  validate?: (value: string) => boolean;
}

/**
 * Free-entry, multi-value filter field for the repeatable string query
 * parameters the contract defines (`tenantCode`, `tenantTag`,
 * `applicationCode`) — there is no fixed vocabulary for these, so a
 * fixed-option select would be wrong.
 */
export function TagsField({ label, helperText, values, onChange, validate }: TagsFieldProps) {
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      options={[]}
      value={values}
      onChange={(_event, newValues) => {
        const accepted = newValues
          .map((value) => value.trim())
          .filter((value) => value.length > 0 && (!validate || validate(value)));
        onChange(accepted);
      }}
      renderInput={(params) => <TextField {...params} label={label} helperText={helperText} />}
    />
  );
}
